/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CancelOrderPaymentIntentInput = {
  readonly paymentIntentId: string;
};

export type BagCancelPreviousIntentMutationVariables = Exact<{
  input: Types.CancelOrderPaymentIntentInput;
}>;

export type BagCancelPreviousIntentMutation = {
  readonly cancelOrderPaymentIntent: {
    readonly __typename: 'CancelOrderPaymentIntentResponse';
    readonly paymentIntentId: string;
    readonly success: boolean;
  };
};

export const BagCancelPreviousIntentDocument = gql`
  mutation BagCancelPreviousIntent($input: CancelOrderPaymentIntentInput!) {
    cancelOrderPaymentIntent(input: $input) {
      __typename
      paymentIntentId
      success
    }
  }
`;

export function useBagCancelPreviousIntentMutation() {
  return Urql.useMutation<
    BagCancelPreviousIntentMutation,
    BagCancelPreviousIntentMutationVariables
  >(BagCancelPreviousIntentDocument);
}
